export interface DarkMode {
    isDarkMode: boolean;
  }
  
  export const initialState: DarkMode = {
    isDarkMode: false,
  };
  